import { ApplicationTypes, SquareHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  genericDimensionComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { SquareHolePropertyPage } from '../ui/property-pages/SquareHolePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const squareHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('SquareHole')
    .attach(() => {
      return {
        title: featureLabels[SquareHole.type],
        subtitle: 'Adjustable square shape',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/square-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('SquareHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <SquareHolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('SquareHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(genericDimensionComponent, 'cornerRadius')
    .withEntity('SquareHole')
    .attach(
      s => ({
        value: s.cornerRadius,
        min: 0.5,
        max: s.sideLength / 2,
        unit: 'mm',
      }),
      v => {
        return {
          cornerRadius: v.value,
        }
      }
    ),
  // TODO: yaml
  attachComponent
    .withComponent(genericDimensionComponent, 'sideLength')
    .withEntity('SquareHole')
    .attach(
      s => ({
        value: s.sideLength,
        min: 1,
        max: Math.min(s.$plate.$maxFeatureSize.x, s.$plate.$maxFeatureSize.y),
        unit: 'mm',
      }),
      v => {
        return {
          sideLength: v.value,
        }
      }
    ),
  attachComponent
    .withEntity('SquareHole')
    .withComponent(dimensionIndicatorComponent, 'radius')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => ({
      ...bendHoleDimensionIndicatorCoordinates(s, {
        startX: s.$sizeX / 2,
        endX: s.$sizeX / 2,
        startY: s.$sizeY / 2,
        endY: s.$sizeY / 2,
        startZ: s.$plate.thickness + 0.1,
        endZ: s.$plate.thickness + 0.1,
        extrusionX: scaleIndicator(5, 50, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
      }),
      extrusionLineDashed: true,
      dashScale: 500,
      arrowHeadType: ArrowHeadType.CONE,
      arrowHeadSize: 6,
      labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
      label: `R=${s.cornerRadius}`,
    })),
]
